/* AlwaysDirect — Wishlist & Compare (localStorage). Writes the item shape the
   /pages/wishlist and /pages/compare templates read: {handle,title,image,price,
   compare_at_price,variant_id,vendor,type}. Keys: ad_wishlist, ad_compare. */
(function () {
  var COMPARE_MAX = 4;

  function keyFor(list) { return list === 'compare' ? 'ad_compare' : 'ad_wishlist'; }
  function read(key) { try { return JSON.parse(localStorage.getItem(key) || '[]'); } catch (e) { return []; } }
  function write(key, list) { localStorage.setItem(key, JSON.stringify(list)); }
  function contains(key, handle) { return read(key).some(function (i) { return i.handle === handle; }); }

  function itemFrom(btn) {
    return {
      handle: btn.getAttribute('data-handle') || '',
      title: btn.getAttribute('data-title') || '',
      image: btn.getAttribute('data-image') || '',
      price: parseInt(btn.getAttribute('data-price') || '0', 10),
      compare_at_price: parseInt(btn.getAttribute('data-compare') || '0', 10),
      variant_id: btn.getAttribute('data-variant') || '',
      vendor: btn.getAttribute('data-vendor') || '',
      type: btn.getAttribute('data-type') || ''
    };
  }

  function syncButtons(list, handle, active) {
    var key = keyFor(list);
    document.querySelectorAll('[data-fav][data-fav-list="' + list + '"][data-handle="' + (window.CSS && CSS.escape ? CSS.escape(handle) : handle) + '"]').forEach(function (b) {
      b.classList.toggle('is-active', active);
    });
  }

  function toggle(btn) {
    var list = btn.getAttribute('data-fav-list') === 'compare' ? 'compare' : 'wishlist';
    var key = keyFor(list);
    var handle = btn.getAttribute('data-handle');
    var items = read(key);
    var idx = -1;
    for (var i = 0; i < items.length; i++) { if (items[i].handle === handle) { idx = i; break; } }

    if (idx > -1) {
      items.splice(idx, 1);
      write(key, items);
      syncButtons(list, handle, false);
      return;
    }
    if (list === 'compare' && items.length >= COMPARE_MAX) {
      btn.classList.add('is-blocked');
      setTimeout(function () { btn.classList.remove('is-blocked'); }, 900);
      return;
    }
    items.push(itemFrom(btn));
    write(key, items);
    syncButtons(list, handle, true);
  }

  function init() {
    document.querySelectorAll('[data-fav]').forEach(function (btn) {
      var list = btn.getAttribute('data-fav-list') === 'compare' ? 'compare' : 'wishlist';
      if (contains(keyFor(list), btn.getAttribute('data-handle'))) btn.classList.add('is-active');
      if (btn.__favBound) return;
      btn.__favBound = true;
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        toggle(btn);
      });
    });
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
